import React from 'react';
import { List, ListItem } from '@op/opds.opux';
import { OfficeBranchDetails } from '../utils/types';
import { chkFieldValue } from '../hooks/OfficeSearchHelper';
import { useTranslation } from 'react-i18next';

interface ContactDetailsProps {
  doc: OfficeBranchDetails;
}
const BulletIcon = () => (
  <span style={{ marginRight: 8, color: '#ee5a00' }}>•</span>
);

const CustomListItem = ({
  label,
  content
}: {
  label: string;
  content: string;
}) => (
  <ListItem
    className="label-contact"
    contentProps={{ style: { flexBasis: '30%', paddingLeft: 0 } }}
    labelProps={{ style: { flexBasis: '70%' } }}
    icon={BulletIcon}
    label={<span className="custom-label-span">{label}</span>}
  >
    <span className="custom-content-span">{content}</span>
  </ListItem>
);

export const ContactDetails = ({ doc }: ContactDetailsProps) => {
  const { t } = useTranslation();
  return (
    <List border="none" style={{ margin: 0, width: '70%' }}>
      {doc.serviceNumberCallService && (
        <CustomListItem
          label={
            doc.contactService
              ? t('ddl.otsikko_pankin_puhelinpalvelu')
              : t('ddl.otsikko_tilit_ja_kortit')
          }
          content={doc.serviceNumberCallService}
        />
      )}
      {doc.serviceNumberCreditService && (
        <CustomListItem
          label={
            doc.contactService
              ? t('ddl.otsikko_rahoituspalvelut')
              : t('ddl.otsikko_luotot')
          }
          content={doc.serviceNumberCreditService}
        />
      )}
      {doc.serviceNumberSavingService && (
        <CustomListItem
          label={
            doc.contactService
              ? t('ddl.otsikko_sijoituspalvelut')
              : t('ddl.otsikko_saastaminen')
          }
          content={doc.serviceNumberSavingService}
        />
      )}
      {doc.serviceNumberLawService && (
        <CustomListItem
          label={
            doc.contactService
              ? t('ddl.otsikko_lakipalvelut')
              : t('ddl.otsikko_lakiasiat')
          }
          content={doc.serviceNumberLawService}
        />
      )}
      {doc.serviceNumberOpRealEstate && (
        <CustomListItem
          label={
            doc.contactService
              ? t('ddl.otsikko_op_kiinteistonvalitys')
              : t('ddl.otsikko_kiinteistovalitys')
          }
          content={doc.serviceNumberOpRealEstate}
        />
      )}
      {doc.serviceNumberCorporateService && (
        <CustomListItem
          label={t('ddl.otsikko_yrityspalvelut')}
          content={doc.serviceNumberCorporateService}
        />
      )}
      {doc.serviceNumberInsuranceService && (
        <CustomListItem
          label={t('ddl.otsikko_vakuutuspalvelut')}
          content={doc.serviceNumberInsuranceService}
        />
      )}
      {chkFieldValue(
        doc.serviceNumberFreeHeading,
        doc.serviceNumberFreePhoneNumber
      ) && (
        <CustomListItem
          label={doc.serviceNumberFreeHeading ?? ''}
          content={doc.serviceNumberFreePhoneNumber ?? ''}
        />
      )}
      {t('ddl.puhelinnumero_verkkopalveluneuvonta_valtakunnallinen') && (
        <CustomListItem
          label={t('ddl.otsikko_verkkopalveluneuvonta_valtakunnallinen')}
          content={t(
            'ddl.puhelinnumero_verkkopalveluneuvonta_valtakunnallinen'
          )}
        />
      )}
      {t('ddl.puhelinnumero_korttien_katoamisilmoitukset_valtakunnallinen') && (
        <CustomListItem
          label={t('ddl.otsikko_korttien_katoamisilmoitukset_valtakunnallinen')}
          content={t(
            'ddl.puhelinnumero_korttien_katoamisilmoitukset_valtakunnallinen'
          )}
        />
      )}
      {t('ddl.puhelinnumero_yrityksen_maksuliike_valtakunnallinen') && (
        <CustomListItem
          label={t('ddl.otsikko_yrityksen_maksuliike_valtakunnallinen')}
          content={t('ddl.puhelinnumero_yrityksen_maksuliike_valtakunnallinen')}
        />
      )}
      {t('ddl.puhelinnumero_vakuutukset_valtakunnallinen') && (
        <CustomListItem
          label={t('ddl.otsikko_vakuutukset_valtakunnallinen')}
          content={t('ddl.puhelinnumero_vakuutukset_valtakunnallinen')}
        />
      )}
    </List>
  );
};
